<div class="modal-header">
	<h2>
		<svg xmlns="http://www.w3.org/2000/svg" width="26" height="25" viewBox="0 0 26 25">
			<g fill="#0CC5D1" fill-rule="evenodd">
				<path d="M24.375 19.458h-9.75v-1.621h2.438a.812.812 0 1 0 0-1.622h-2.438v-1.621h2.438a.812.812 0 1 0 0-1.622h-2.438v-1.621h2.438a.812.812 0 1 0 0-1.622h-2.438V8.108h2.438a.812.812 0 1 0 0-1.622h-2.438V4.864h9.75v14.594zM13 22.534L1.625 20.407V3.916L13 1.789v20.745zM25.188 3.243H14.624V.811a.808.808 0 0 0-.962-.796l-13 2.432A.809.809 0 0 0 0 3.243V21.08c0 .389.278.724.663.796l13 2.432a.813.813 0 0 0 .962-.796V21.08h10.563a.812.812 0 0 0 .812-.811V4.054a.812.812 0 0 0-.813-.811z"/>
				<path d="M20.129 8.387h1.677a.839.839 0 0 0 0-1.677H20.13a.839.839 0 0 0 0 1.677M20.129 11.892h1.677a.839.839 0 0 0 0-1.678H20.13a.839.839 0 0 0 0 1.678M20.129 14.677h1.677a.839.839 0 0 0 0-1.677H20.13a.839.839 0 0 0 0 1.677M20.129 17.463h1.677a.839.839 0 0 0 0-1.677H20.13a.839.839 0 0 0 0 1.677M7.953 12.351l2.681-3.447a.838.838 0 1 0-1.323-1.032l-2.483 3.193-2.092-2.391a.838.838 0 1 0-1.263 1.104l2.306 2.636-2.338 3.007a.84.84 0 0 0 .663 1.353c.248 0 .496-.11.66-.322l2.14-2.752 2.439 2.787a.836.836 0 0 0 1.184.08.837.837 0 0 0 .079-1.183L7.953 12.35z"/>
			</g>
		</svg>
		<ng-container i18n="@@common.import_clients">Import Clients</ng-container>
	</h2>
	<button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="activeModal.dismiss()">
		<svg version="1.1" x="0px" y="0px" width="14" height="14" viewBox="0 0 14 14">
			<path class="icon-stroke" fill="none" stroke-width="2" stroke-linecap="square"
				d="M2.8,11.2l8.5-8.5 M2.8,2.8l8.5,8.5" />
		</svg>
	</button>
</div>
<div class="modal-body">
	<form [formGroup]="clientForm" (ngSubmit)="clientForm.valid && submit()" class="new-client flex-container" #newClientForm="ngForm">

		<fieldset>
			<label i18n="@@common.upload_file">Upload a file</label>
			<file-pond #receiptInvoicePhoto 
				class="filepond"
				[options]="pondOptions" 
				[files]="uploadedFile"
				(oninit)="pondHandleInit()"
				(onaddfile)="pondHandleAddFile($event)"
				(onprocessfileabort)="removeFile()"
				>
			</file-pond>
		</fieldset>

	</form>
</div>
<div class="modal-footer">
	<button type="button" (click)="downloadTemplate()" class="tu-btn transparent" >
		<ng-container i18n="@@common.sample_template">Sample Template</ng-container>
		<svg xmlns="http://www.w3.org/2000/svg" width="26" height="25" viewBox="0 0 26 25">
			<g fill="#0CC5D1" fill-rule="evenodd">
				<path d="M24.375 19.458h-9.75v-1.621h2.438a.812.812 0 1 0 0-1.622h-2.438v-1.621h2.438a.812.812 0 1 0 0-1.622h-2.438v-1.621h2.438a.812.812 0 1 0 0-1.622h-2.438V8.108h2.438a.812.812 0 1 0 0-1.622h-2.438V4.864h9.75v14.594zM13 22.534L1.625 20.407V3.916L13 1.789v20.745zM25.188 3.243H14.624V.811a.808.808 0 0 0-.962-.796l-13 2.432A.809.809 0 0 0 0 3.243V21.08c0 .389.278.724.663.796l13 2.432a.813.813 0 0 0 .962-.796V21.08h10.563a.812.812 0 0 0 .812-.811V4.054a.812.812 0 0 0-.813-.811z"/>
				<path d="M20.129 8.387h1.677a.839.839 0 0 0 0-1.677H20.13a.839.839 0 0 0 0 1.677M20.129 11.892h1.677a.839.839 0 0 0 0-1.678H20.13a.839.839 0 0 0 0 1.678M20.129 14.677h1.677a.839.839 0 0 0 0-1.677H20.13a.839.839 0 0 0 0 1.677M20.129 17.463h1.677a.839.839 0 0 0 0-1.677H20.13a.839.839 0 0 0 0 1.677M7.953 12.351l2.681-3.447a.838.838 0 1 0-1.323-1.032l-2.483 3.193-2.092-2.391a.838.838 0 1 0-1.263 1.104l2.306 2.636-2.338 3.007a.84.84 0 0 0 .663 1.353c.248 0 .496-.11.66-.322l2.14-2.752 2.439 2.787a.836.836 0 0 0 1.184.08.837.837 0 0 0 .079-1.183L7.953 12.35z"/>
			</g>
		</svg>
	</button>
	<button type="button" (click)="submitted=true; newClientForm.ngSubmit.emit()" class="tu-btn pink" i18n="@@common.import">Import</button>
</div>
